import { API_CANDIDATE_URL } from '../constants/base-urls'
import type { ICandidateExplore, IPaginationParam, IPaginationResponse } from '../types'
import { createAxiosInstance } from '../utils'

type ParamsType = {
  city?: string
  educ?: string
  gender?: string
  keyword?: string
  lat: number
  lng: number
  max_age?: number
  min_age?: number
} & IPaginationParam

const axios = createAxiosInstance({
  baseURL: API_CANDIDATE_URL,
  withAuth: true,
})

export const exploreCandidate = (params: ParamsType) => {
  return axios
    .get<{ data: IPaginationResponse<ICandidateExplore> }>(`/candidate/explore`, { params })
    .then((response) => response.data.data)
}
